import React, { useMemo, useState } from 'react'
import QueryBuilder from 'react-querybuilder'
import { QueryBuilderDnD } from '@react-querybuilder/dnd'
import * as ReactDnD from 'react-dnd'
import * as ReactDndHtml5Backend from 'react-dnd-html5-backend'
// import * as ReactDndTouchBackend from 'react-dnd-touch-backend'
import CustomValueSelector, {
    CustomOperatorSelector,
    CustomCombinatorSelector,
    CustomDragIcon,
} from '../filters/ValueSelector'
import { CustomValueEditor } from './ValueEditor'
import {
    AddGroupActionElement,
    AddRuleActionElement,
    RemoveGroupActionElement,
    RemoveRuleActionElement,
} from '../filters/ActionElement'

const QueryBuilderWrapper = (props) => {
    return (
        <QueryBuilderDnD
            dnd={{
                ...ReactDnD,
                ...ReactDndHtml5Backend,
                // ...ReactDndTouchBackend,
            }}
        >
            <QueryBuilder
                controlElements={{
                    inlineCombinator: CustomCombinatorSelector, // combinatorSelector: CustomCombinatorSelector, //combinator is not needed for independent-combinator style, instead we use inlineCombinator
                    fieldSelector: CustomValueSelector,
                    operatorSelector: CustomOperatorSelector,
                    valueEditor: CustomValueEditor,
                    addGroupAction: props.groupsIncluded
                        ? AddGroupActionElement
                        : null,
                    removeGroupAction: RemoveGroupActionElement,
                    addRuleAction: AddRuleActionElement,
                    removeRuleAction: RemoveRuleActionElement,
                    dragHandle: CustomDragIcon,
                }}
                // translations={{
                //     dragHandle: {
                //         label: (
                //             <span
                //                 className={`drag-icon-wrapper `}
                //                 title=""
                //                 // ref={ref}
                //                 style={{
                //                     // fontSize: '12px',
                //                     // padding: '0 4px',
                //                     cursor: 'grab',
                //                 }}
                //             >
                //                 <FaGripVertical />{' '}
                //             </span>
                //         ),
                //     },
                // }}
                addRuleToNewGroups
                showCombinatorsBetweenRules
                // context={{
                //     viewOnly: props.viewOnly,
                // }}
                {...props}
            />
        </QueryBuilderDnD>
    )
}

export default QueryBuilderWrapper
